import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle.editar.movimientos.buscar', {
    url: '/buscar?{folio}&{folios}&{importe:int}&{importeModalidad}&{naturaleza}&{fechaInicio:date}&{fechaFinal:date}&{notas}&{id_concepto}',
    template: '<empleados-empleado-servicios-buscar id-empresa="idEmpresa" id-empleado="idEmpleado" id-moneda="idMoneda" filtro="filtro"/>',
    params: {folios: {array: true}},
    data: {title: 'Servicios'},
    controller ($scope, $stateParams, idEmpleado, idMoneda) {
      $scope.idEmpresa = '05'
      $scope.idEmpleado = idEmpleado
      $scope.idMoneda = idMoneda
      $scope.filtro = {
        folio: $stateParams['folio'],
        folios: $stateParams['folios'],
        id_concepto: $stateParams['id_concepto'],
        importe: $stateParams['importe'],
        importeModalidad: $stateParams['importe'] ? ($stateParams['importeModalidad'] || '=') : undefined,
        naturaleza: $stateParams['naturaleza'] || 'T',
        fechaInicio: $stateParams['fechaInicio'],
        fechaFinal: $stateParams['fechaFinal'] || $stateParams['fechaInicio'],
        notas: $stateParams['notas'],
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/detalle/editar/movimientos/buscar.js